/**
 * TeamSystem Impact - Frontend Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { installChunkRecovery } from './lib/chunkRecovery';
import './index.css';

// Recupera dai 404 sui chunk lazy durante il rollover di un deploy.
// Deve girare prima del render: senza handler l'errore propaga oltre
// <Suspense> e la pagina resta bianca.
installChunkRecovery();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Web Vitals performance monitoring (WS3.4)
import('./reportWebVitals').then(({ reportWebVitals }) => reportWebVitals());
